import { useIntl } from '@/intl'
import { useState } from 'react'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    planName: translate({ id: 'settings.messagingPlan.view.emailPlan.warning.title' }),
    warningDescription: translate({
      id: 'settings.messagingPlan.view.emailPlan.warning.description',
    }),
    currentPlanLabel: translate({
      id: 'settings.messagingPlan.view.smsPlan.currentPlanLabel',
    }),
    currentPlanDescription: translate({
      id: 'settings.messagingPlan.view.smsPlan.currentPlanDescription',
    }),
    changePlan: translate({ id: 'settings.messagingPlan.view.changePlan' }),
    durationMonths: (duration: number) =>
      translate({ id: 'settings.messagingPlan.view.smsPlanDurationMonths', values: { duration } }),
    expiryDate: translate({ id: 'settings.messagingPlan.view.smsPlanExpiryDatesLabel' }),
    expiring: (expireDate: string, daysToExpire: number) =>
      translate({
        id: 'settings.messagingPlan.view.smsPlanExpiresOn',
        values: { expireDate, daysToExpire },
      }),
    changePlanDisabled: translate({ id: 'settings.messagingPlan.view.changePlan.tooltip.title' }),
  }))

  return api
}
